import React from 'react';
import cn from 'classnames';

import { Button } from '@landing/ui';

import * as styles from './FormSubmit.module.scss';

export const FormSubmit = ({
  className,
  size = 'md',
  title = 'Send',
  fullWidthMobile = true,
  isSubmitting,
}) => {
  return (
    <div className={cn(styles.submit, className)}>
      <div className={styles.buttonWrap}>
        <Button
          type="submit"
          size={size}
          fullWidthMobile={fullWidthMobile}
          disabled={isSubmitting}
          isSubmitting={isSubmitting}
        >
          {title}
        </Button>
      </div>
    </div>
  );
};
